/**
 * Same-origin GET pixel, defined in `public/index.html` outside the bundle. It reaches Loki when the
 * Sentry tunnel does not: no POST body, no blocker signature, and the ticket token rides along in
 * `u=` because the beacon reads it from `location.pathname`.
 *
 * Lived inside `services/receiptUpload.ts` until CPAYMENT-1822, when the pick step needed the same
 * channel. Nothing here may throw into the payment flow.
 */
export const beacon = (stage: string): void => {
  try {
    (window as any).__b?.(stage);
  } catch {
    // telemetry must never reach the payment flow
  }
};
